import { render } from "./asset-type-form.vue?vue&type=template&id=b173d78e"
import script from "./asset-type-form.vue?vue&type=script&lang=js"
export * from "./asset-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__